import { gql } from '@apollo/client'

export const storyRemoveById = gql`
  mutation StoryRemoveById($_id: String!) {
    storyRemoveById(_id: $_id) {
      recordId
    }
  }
`
